export class ShippingUrlManager {
    static updateQueryString(key: string, value: string): void {
        const url = new URL(window.location.href);
        if (value) {
            url.searchParams.set(key, value);
        } else {
            url.searchParams.delete(key);
        }
        window.history.pushState({}, "", url.toString());
    }

    static getQueryParam(key: string): string | null {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(key);
    }

    static checkQueryStringAndLoad(key: string, callback: (value: string) => void): void {
        const value = this.getQueryParam(key);
        if (value && value.trim() !== "") {
            callback(value.trim());
        }
    }
}

